$(function() {

  window.activeModal = gsap.timeline();

  function modalTl(modal) {
        
    modal = document.querySelector(modal);

    var tl = gsap.timeline({
      paused: true
    });

    // Modal opacity
    tl.fromTo(modal, {
      autoAlpha: 0,
    }, {
      autoAlpha: 1,
      duration: .6,
    }, 0);
    
    // Image fade
    tl.fromTo(modal.querySelector('.modal-img-container'), {
      autoAlpha: 0
    }, {
      autoAlpha: 1,
      duration: .6
    }, .8);

    // Links 
    tl.fromTo( modal.querySelectorAll(".modal-nav.md-hide .modal-nav-link"), {
      clipPath: 'inset(0% 100% 0% 0%)',
      x: -15,
      autoAlpha: 0,
    }, {
      clipPath: 'inset(0% 0% 0% 0%)',
      x: 0,
      autoAlpha: 1,
      duration: .8,
      stagger: .2
    }, .8)


    // Content
    tl.fromTo(modal.querySelectorAll('.modal-scrollable'), {
      autoAlpha: 0,
      clipPath: 'inset(100% 0% 0% 0%)'
    }, {
      autoAlpha: 1,
      clipPath: 'inset(0% 0% 0% 0%)',
      duration: .8,
      stagger: .2,
    }, 1.1).fromTo(modal.querySelectorAll('.modal-scrollable > .modal-col-inner'), {
      y: '20%',
    }, {
      y: '0%',
      duration: .8,
      stagger: .2,
    }, 1.1);
    

    // Logo
    tl.fromTo(modal.querySelector('.modal-motif'), {
      autoAlpha: 0,
      x: '15%',
      y: '15%',
    }, {
      autoAlpha: 1,
      x: '0%',
      y: '0%',
      duration: 1
    }, 1);
    

    return tl;
  }


  function modalTransition(modalCurrent, nextModal) {
    var transitionTl = gsap.timeline({ onComplete: playNextTl });

    transitionTl.fromTo(modalCurrent.querySelectorAll('.modal-scrollable'), {
      autoAlpha: 1,
      clipPath: 'inset(0% 0% 0% 0%)',
    }, {
      autoAlpha: 0,
      clipPath: 'inset(100% 0% 0% 0%)',
      duration: .8,
      stagger: .2,
    }, 0).fromTo(modalCurrent.querySelectorAll('.modal-scrollable > .modal-col-inner'), {
      y: '0%',
    }, {
      y: '20%',
      duration: .8,
      stagger: .2,
    }, 0);

    function playNextTl() {
      var nextTl = gsap.timeline();
      nextTl.to(modalCurrent, {autoAlpha: 0, duration: .6}, 0);
      nextTl.to(nextModal, {autoAlpha: 1, duration: .6, onComplete: function() {
        modalCurrent.classList.remove('active');
        nextModal.classList.add('active');
      }}, 0);

      activeModal.progress(1);

      nextTl.fromTo(nextModal.querySelectorAll('.modal-scrollable'), {
        autoAlpha: 0,
        clipPath: 'inset(100% 0% 0% 0%)',
      }, {
        autoAlpha: 1,
        clipPath: 'inset(0% 0% 0% 0%)',
        duration: .8,
        stagger: .2,
      }, 0.4).fromTo(nextModal.querySelectorAll('.modal-scrollable > .modal-col-inner'), {
        y: '20%',
      }, {
        y: '0%',
        duration: .8,
        stagger: .2,
      }, .4);
    }
  }

  $(".js-close-modal").on("click", function(e) {
    e.preventDefault();
    $(".fs-modal").removeClass('active');
    activeModal.reverse();
  });


  $(".modal-nav-links > a").on("click", function(e) {
    e.preventDefault();
    var modalCurrent = document.querySelector(".fs-modal.active");
    var nextModal = document.querySelector( $(this).attr('data-target') );
    activeModal = modalTl($(this).attr("data-target"));

    modalTransition(modalCurrent, nextModal);
  });


  $(".value-card, .text-link[data-target]").on("click", function(e) {
    e.preventDefault();
    document.querySelector($(this).attr("data-target")).classList.add('active');
    activeModal = modalTl($(this).attr("data-target")).play();
  });
});